import type { FC } from 'react';

import { AdviceCardImageContainer } from '@eneco/custom-components/InspirationAdviceFilter';
import { Box, Card, Skeleton } from '@eneco/sparky';

export const AdviceCardSkeleton: FC = () => (
  <Card>
    <AdviceCardImageContainer borderTopLeftRadius="m" borderTopRightRadius="m" overflow="hidden">
      <Skeleton variant="rectangular" width="100%" height="200px" />
    </AdviceCardImageContainer>
    <Box
      backgroundColor="backgroundPrimary"
      padding="7"
      paddingBottom="8"
      borderBottomLeftRadius="m"
      borderBottomRightRadius="m">
      <Skeleton width="90%" height="20px" />
      <Skeleton width="60%" height="20px" />
    </Box>
  </Card>
);
